import React, { Component } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import { Link, withRouter } from 'react-router'
import { handleGameClick, handleErrorCode, showErrorMessage, renderGame } from './gameUtils.jsx'
// import SignIn from '../../SignIn.jsx'
import Loader from '../../../../shared/components/Loader.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from './messages.js'
import recentIcon from './assets/recent.svg'
import resetIcon from './assets/resetIcon.svg'
import SearchInput from './Input.jsx'
import { Select } from '../../Select/Select.jsx'

class GameLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      categories: [],
      providers: [],
      popularGames: [],
      anotherGames: [],
      selectedCategoryId: '',
      selectedProviderId: '',
      searchTerm: this.props.params.searchTerm || '',
      allGames: [],
      page: 1,
      hasMoreGames: true,
      isLoading: true,
      placeholder: '',
      favoriteGames: this.getFavoriteGamesFromStorage() || [],
      showPopular: true,
      showType: true,
      hideAllGames: false,
    }
  }
  componentDidMount = () => {
    const { location } = this.props

    this.fetchLobbyGames()
    this.fetchProviders()
    this.fetchCategories()
    const cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || []
    const cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || []

    this.setState({
      popularGames: cachedPopularGames,
      anotherGames: cachedAnotherGames,
      isLoading: false,
    })
    if (this.props.params.searchTerm) {
      this.setState({ showType: false, showPopular: false }, () => this.fetchAllGames(''))
    }
    if (location.query && !isNaN(location.query.provider) && location.query.provider !== '') {
      this.setState(
        {
          selectedProviderId: Number(location.query.provider),
          showPopular: false,
          showType: false,
        },
        () => this.fetchAllGames(Number(location.query.provider))
      )
    }
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      (prevState.selectedProviderId !== this.state.selectedProviderId && this.state.selectedProviderId === '') ||
      (prevState.selectedCategoryId !== this.state.selectedCategoryId && this.state.selectedCategoryId === '')
    ) {
      const cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || []
      const cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || []
      this.setState(
        {
          popularGames: cachedPopularGames,
          anotherGames: cachedAnotherGames,
          isLoading: false,
        },
        this.updateFilteredGames
      )
    }

    if (prevProps.languageId !== this.props.languageId) {
      this.fetchLobbyGames()
      this.fetchCategories()
    }
  }

  handleScroll = () => {
    const { isLoading, hasMoreGames, selectedProviderId } = this.state
    if (!selectedProviderId || isLoading || !hasMoreGames) return
  
    const documentHeight = document.documentElement.scrollHeight
  
    if (window.scrollY + window.innerHeight >= documentHeight - 150) {
      this.loadMoreGames()
    }
  }

  loadMoreGames = () => {
    const { selectedProviderId } = this.state

    this.setState(prevState => {
      const newPage = prevState.page + 1
      this.fetchAllGames(selectedProviderId, newPage, true)
      return { page: newPage }
    })
  }

  getGamesFromStorage = () => {
    try {
      const games = localStorage.getItem('lobbyGames')
      return games ? JSON.parse(games) : []
    } catch (error) {
      console.error('Failed to parse games from localStorage:', error)
      return []
    }
  }

  getFavoriteGamesFromStorage = () => {
    try {
      const favorites = localStorage.getItem('favoriteGames')
      return favorites ? JSON.parse(favorites) : []
    } catch (error) {
      console.error('Failed to parse favorite games from localStorage:', error)
      return []
    }
  }

  saveFavoriteGamesToStorage = favoriteGames => {
    localStorage.setItem('favoriteGames', JSON.stringify(favoriteGames))
  }

  filterGames = games => {
    const { selectedCategoryId } = this.state

    return games.filter(game => {
      const matchesCategory = selectedCategoryId === '' || game.GameTypeId === parseInt(selectedCategoryId)

      return matchesCategory
    })
  }

  fetchAllGames = async (providerId = '', page = 1, append = false) => {
    this.setState({ isLoading: true })
    try {
      const { searchTerm } = this.state
      const providerQuery = providerId ? `&providers=${providerId}` : ''
      const searchQuery = searchTerm ? `&name=${searchTerm}` : ''
      const offset = (page - 1) * 64

      const responseAllGames = await fetch(`/api/games/all-games?limit=64&offset=${offset}${providerQuery}${searchQuery}`)
      if (!responseAllGames.ok) {
        throw new Error('Failed to fetch all games')
      }
      const dataAllGames = await responseAllGames.json()
      const newGames = dataAllGames.Items || []

      this.setState(prevState => ({
        allGames: append ? [...prevState.allGames, ...newGames] : newGames,
        hasMoreGames: newGames.length === 64,
      }))
    } catch (error) {
      console.error('Failed to fetch all games:', error)
      this.setState({ isLoading: false, hasMoreGames: false })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  fetchLobbyGames = async () => {
    this.setState({ isLoading: true })
    try {
      let dataLobby = { Items: [], TopGames: [], GameTypes: [] }
      const responseLobbyGames = await fetch(`/api/games/lobby?limit=80&language=${this.props.languageId}`)
      if (!responseLobbyGames.ok) throw new Error('Failed to fetch lobby games')
      dataLobby = await responseLobbyGames.json()

      this.saveGamesToStorage(dataLobby.TopGames || [], dataLobby.GameTypes || [])
      this.setState({
        lobbyGames: dataLobby.Items || [],
        popularGames: dataLobby.TopGames || [],
        anotherGames: dataLobby.GameTypes || [],
      })
    } catch (error) {
      console.error('Failed to fetch lobby games:', error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  fetchCategories = async () => {
    try {
      const responseCategories = await fetch(`/api/games/types?language=${this.props.languageId}`)
      if (!responseCategories.ok) throw new Error('Failed to fetch categories')
      const dataCategories = await responseCategories.json()

      if (dataCategories.Items) {
        this.setState({
          categories: dataCategories.Items || [],
        })
      }
    } catch (error) {
      console.error('Failed to fetchCategories:', error)
    }
  }

  fetchProviders = async () => {
    try {
      const responseProviders = await fetch('/api/games/providers')
      if (!responseProviders.ok) throw new Error('Failed to fetch providers')
      const dataProviders = await responseProviders.json()

      if (dataProviders.Items) {
        this.setState({
          providers: dataProviders.Items || [],
        })
      }
    } catch (error) {
      console.error('Failed to fetchProviders:', error)
    }
  }

  saveGamesToStorage = (popularGames, anotherGames) => {
    localStorage.setItem('popularGames', JSON.stringify(popularGames))
    localStorage.setItem('anotherGames', JSON.stringify(anotherGames))
  }

  pinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    try {
      const response = await fetch(`/api/games/pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.addGameToFavorites(gameId)
      } else {
        this.removeGameFromFavorites(gameId)
      }
    } catch (error) {
      console.error('Error pinning the game:', error)
    }
  }
  unpinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
      return
    }

    try {
      const response = await fetch(`/api/games/un-pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.removeGameFromFavorites(gameId)
      } else {
        console.error('Failed to unpin the game')
      }
    } catch (error) {
      console.error('Error unpinning the game:', error)
    }
  }
  addGameToFavorites = gameId => {
    const { favoriteGames, popularGames, anotherGames } = this.state

    let gameToAdd = popularGames.find(game => game.Id === gameId)

    if (!gameToAdd) {
      for (const gameType of anotherGames) {
        gameToAdd = gameType.Games.find(game => game.Id === gameId)
        if (gameToAdd) break
      }
    }
    if (gameToAdd) {
      const updatedFavorites = [...favoriteGames, gameToAdd]
      this.setState({ favoriteGames: updatedFavorites }, () => {
        this.saveFavoriteGamesToStorage(updatedFavorites)
      })
    }
  }

  handleSearchChange = event => {
    this.setState({ searchTerm: event.target.value })
  }

  handleSearchSubmit = () => {
    const { searchTerm } = this.state
    this.setState({ showType: false, showPopular: false, page: 1, hasMoreGames: true }, () => this.fetchAllGames(''))
    this.props.router.push(`/games/${searchTerm}`)
  }

  handleProviderChange = value => {
    if (value === '') {
      this.reloadPage()
    } else {
      this.setState(
        {
          selectedProviderId: value,
          showPopular: false,
          showType: false,
          page: 1, 
          hasMoreGames: true
        },
        () => this.fetchAllGames(value)
      )
    }
  }

  handleCategoryChange = event => {
    const selectedCategoryId = event.target.value
    if (selectedCategoryId === '') {
      // temporary
      this.reloadPage()
    } else {
      this.setState({ selectedCategoryId, showPopular: false, hideAllGames: true }, this.updateFilteredGames)
    }
  }

  updateFilteredGames = () => {
    const { selectedCategoryId, selectedProviderId } = this.state
    const cachedPopularGames = JSON.parse(localStorage.getItem('popularGames')) || []
    const cachedAnotherGames = JSON.parse(localStorage.getItem('anotherGames')) || []

    const filterGames = games => {
      return games.filter(game => {
        const matchesCategory = selectedCategoryId === '' || game.GameTypeId === parseInt(selectedCategoryId)
        const matchesProvider = selectedProviderId === '' || game.ProviderId === parseInt(selectedProviderId)
        return matchesCategory && matchesProvider
      })
    }

    const filteredPopularGames = filterGames(cachedPopularGames)
    const filteredAnotherGames = cachedAnotherGames.map(type => ({
      ...type,
      Games: filterGames(type.Games),
    }))

    this.setState({
      popularGames: filteredPopularGames,
      anotherGames: filteredAnotherGames.filter(type => type.Games.length > 0),
    })
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна.')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }
  removeGameFromFavorites = gameId => {
    const { favoriteGames } = this.state
    const updatedFavorites = favoriteGames.filter(game => game.Id !== gameId)

    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }
  chunkArray = (array, chunkSize) => {
    const result = []
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize))
    }
    return result
  }

  reloadPage = () => {
    window.location.reload()
  }

  handleResetSearch = () => {
    this.setState(
      {
        searchTerm: '',
        showType: true,
        showPopular: true,
        selectedCategoryId: '',
        selectedProviderId: '',
      },
      () => {
        this.props.router.push(`/games`)
        this.fetchLobbyGames()
      }
    )
  }

  render() {
    const {
      categories,
      selectedCategoryId,
      selectedProviderId,
      searchTerm,
      isLoading,
      providers,
      popularGames,
      anotherGames,
      allGames,
      showPopular,
      showType,
      hideAllGames,
    } = this.state

    const filteredPopularGames = this.filterGames(popularGames)
    const filteredAnotherGames = anotherGames
      .map(type => ({
        ...type,
        Games: this.filterGames(type.Games),
      }))
      .filter(type => type.Games.length > 0)

    const sliderSettings = {
      speed: 400,
      infinite: false,
      slidesPerRow: 1,
      slidesToShow: 6,
      slidesToScroll: 2,
      rows: 2,
    }

    return (
      <div className="game-layout">
        {isLoading && <Loader />}
        <div className="game-search-bar">
          <div className="game-search-bar">
            <img
              src={resetIcon}
              alt="Reset Search"
              width={30}
              onClick={this.handleResetSearch}
              style={{ cursor: 'pointer' }}
            />{' '}
            <SearchInput
              searchTerm={searchTerm}
              onSearchChange={this.handleSearchChange}
              onSearchSubmit={this.handleSearchSubmit}
            />
            <Select
              options={[
                {
                  label: <FormattedMessage {...messages.allProviders} />,
                  value: '',
                },
                ...providers.map(provider => {
                  let tag = undefined

                  if (provider.IsTop) {
                    tag = { text: <FormattedMessage {...messages.hot} />, type: 'top' }
                  } else if (provider.IsNew) {
                    tag = { text: <FormattedMessage {...messages.new} />, type: 'new' }
                  }

                  return {
                    label: provider.Name,
                    value: provider.Id,
                    ...(tag ? { tag } : {}),
                  }
                }),
              ]}
              onChange={this.handleProviderChange}
              value={selectedProviderId}
            />
            <select className="game-type-select" onChange={this.handleCategoryChange} value={selectedCategoryId}>
              <option value="">
                <FormattedMessage {...messages.allTypes} />
              </option>
              {categories.map(category => (
                <option key={category.Id} value={category.Id}>
                  {category.Name}
                </option>
              ))}
            </select>
            <Link to="/games/favorites" className="tooltip-container">
              <button className="star-button">★</button>
              <span className="tooltip-text">
                <FormattedMessage {...messages.showFavorites} />
              </span>
            </Link>
            <Link to="/games/recent" className="tooltip-container">
              <button className="refresh-button">
                <img src={recentIcon} alt="" width={44} />
              </button>
              <span className="tooltip-text">
                <FormattedMessage {...messages.showRecentGames} />
              </span>
            </Link>
          </div>
        </div>

        {showPopular && !!filteredPopularGames.length && (
          <div className="game-section">
            {showPopular && (
              <h1 className="section-title">
                <FormattedMessage {...messages.popular} />
              </h1>
            )}
            <div className="slider-container">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {showPopular && (
                  <Link to={`/games/popularGames`}>
                    <button className="showAll">
                      <FormattedMessage {...messages.showAll} />
                    </button>
                  </Link>
                )}
              </div>
              <Slider {...sliderSettings}>
                {filteredPopularGames.map(game =>
                  renderGame(
                    game,
                    this.handleGameClickWrapper,
                    this.state.favoriteGames,
                    this.pinGame,

                    this.unpinGame
                  )
                )}
              </Slider>{' '}
            </div>
          </div>
        )}

        {showType &&
          filteredAnotherGames.map(type => (
            <div className="game-section" key={type.Id}>
              <h1 className="section-title">{type.Name}</h1>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {type.Games.length > 0 && type.Games[0].GameTypeId !== undefined ? (
                  <button className="showAll">
                    <Link to={`/games/types/${type.Games[0].GameTypeId}`}>
                      <FormattedMessage {...messages.showAll} />
                    </Link>
                  </button>
                ) : (
                  <button className="showAll" disabled>
                    <FormattedMessage {...messages.showAll} />
                  </button>
                )}
              </div>
              <Slider {...sliderSettings}>
                {type.Games.map(game =>
                  renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)
                )}
              </Slider>
            </div>
          ))}

        {/* TUT */}
        <div style={{ display: 'flex', maxWidth: '1400px', flexWrap: 'wrap', gap: '20px' }}>
          {!showType && allGames.length > 0 ? (
            allGames.map(game => (
              <div key={game.Id}>
                {renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)}
              </div>
            ))
          ) : (
            <div className="no-games-message"></div>
          )}
        </div>

        {/* ALL GAMES CATEGORY */}
        {!hideAllGames && showType ? (
          <div className="game-section">
            <h1 className="section-title">
              <FormattedMessage {...messages.allGames} />
              {/* все игры */}
            </h1>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button className="showAll">
                <Link to={`/games/allGames`}>
                  <FormattedMessage {...messages.showAll} />
                </Link>
              </button>
            </div>
            <br />
            <div className="slider-container">
              <Slider {...sliderSettings}>
                {allGames.map(game =>
                  renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)
                )}
              </Slider>{' '}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = (state, dispatch) => ({
  languageId: state.application.get('languageId'),
  user: state.auth.get('user'),
  dispatch,
})

export default withRouter(connect(mapStateToProps)(GameLayout))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/GamesPageNewLayout/GamesPageNew.jsx